<template>
    <v-container fluid grid-list-lg>
        <v-layout wrap > 
                       
            <v-flex xs12>  
                <app-manejo-cuentas-banco propName= "cuentasBanco" :value="value" ></app-manejo-cuentas-banco>
            </v-flex>

        </v-layout>        
    </v-container>
</template>

<script>
  export default {
  data() {
      return {        
      }
  },  
  props: {
    value: {
      type: Object,
      required: false,
      default: function () { return {email:'', twiter: '', facebook:''}}
    },
    editMode: {
      type: Boolean,
      default: true
    },
  },
}

</script>
